/* ============================================================
   Bundle Picker — bundle-picker.js
   Save to: Assets/bundle-picker.js
   ============================================================ */

(function () {
  'use strict';

  function boot() {

  const BUNDLE_SIZE       = (window.BP_CONFIG && window.BP_CONFIG.bundleSize) || 7;
  const BUNDLE_VARIANT_ID = (window.BP_CONFIG && window.BP_CONFIG.bundleVariantId) || 0;
  // Page size is per-breakpoint (grid is 2/row under 750px, 4/row above) so the
  // owner can tune ROWS independently. Resolved once at boot; a rare mid-session
  // resize across 750px keeps the boot value until reload (pagination state stays sane).
  const PER_PAGE = (function () {
    const c = window.BP_CONFIG || {};
    const isMobile = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
    return (isMobile && c.productsPerPageMobile) || c.productsPerPage || 20;
  })();
  // Offer total in CENTS, derived from the section's price display in liquid —
  // never hardcode (a stale 8500 was mis-reporting Meta Pixel values).
  const BUNDLE_PRICE      = (window.BP_CONFIG && window.BP_CONFIG.bundlePrice) || 8500;

  /* Default display order (best-seller order from the source store) so the grid
     shows a VARIETY of categories up front instead of grouping by collection.
     Handles not listed keep their original order and sort after these. */
  const DEFAULT_ORDER = (window.BP_DEFAULT_ORDER && window.BP_DEFAULT_ORDER.length) ? window.BP_DEFAULT_ORDER : [
    // fallback order if the 'Bundle Featured Order' collection is unavailable
    'capri-cuff-bangle', 'ocean-initial-necklace', 'sculptural-adjustable-ring', 'curved-cuff-bracelet',
    'pear-cut-ring', 'full-aura-ring', 'soft-vintage-studs', 'sculptural-open-cuff',
    'teardrop-earrings', 'polished-nail-bracelet', 'timeless-love-bracelet', 'london-link-bracelet',
    'starlight-bracelet', 'iconic-clover-bracelet', 'sienna-watchband-bracelet', 'london-link-necklace',
    'delia-tennis-bracelet', 'marlowe-tennis-bracelet', 'rosalind-mesh-bracelet', 'infinity-loop-earrings',
    'wren-clover-bracelet', 'odette-initial-bangle', 'iconic-clover-necklace', 'madrid-layered-necklace',
    'margot-emerald-bracelet', 'lennox-paperclip-bracelet', 'marlowe-tennis-necklace', 'carys-diamond-ring',
    'soraya-watchband-bracelet', 'dual-chain-ring-necklace', 'bubble-letter-necklace', 'pia-diamond-ring',
    'london-link-earrings', 'noor-heart-necklace', 'suki-bangle-set', 'barcelona-bracelet',
    'yara-emerald-bracelet', 'linnea-heart-bracelet', 'luxe-baguette-bracelet', 'venetian-embrace-ring',
    'cleo-cuff-bracelet', 'ruby-tennis-bracelet', 'orbita-aura-ring', 'marnie-bracelet',
    'lennox-paperclip-necklace', 'classic-hoop-earrings-set', 'greta-bangle', 'anouk-layered-necklace',
    'dahlia-paperclip-necklace', 'mireille-bracelet', 'orbita-hoop-earrings-set', 'zenith-layered-necklace',
    'baroque-pearl-necklace', 'saskia-stacked-ring', 'zola-bangle', 'aurora-layered-necklace',
    'faye-bracelet', 'romy-crown-and-cross-necklace', 'legacy-link-bracelet', 'maren-herringbone-bracelet',
    'heartlight-necklace', 'maren-herringbone-necklace', 'indra-layered-necklace', 'layered-pearl-initial-letter-necklace',
    'vesna-rope-bracelet', 'esme-loop-ring', 'liora-bracelet', 'nova-bar-necklace',
    'tamsin-tennis-bracelet', 'aura-birthstone-necklace', 'hadley-wrap-ring', 'teardrop-necklace',
    'noa-marble-ring', 'sahar-ring', 'calista-bangle', 'butterfly-bliss-bracelet',
    'annika-star-ring', 'florence-faith-necklace', 'marisol-bracelet', 'milan-bangle',
    'lumi-pearl-necklace', 'talia-compass-necklace', 'nairobi-ring', 'aveline-earrings',
    'vesna-rope-necklace', 'waterfall-earrings', 'twist-of-glamour-earrings', 'freja-oval-bracelet',
    'iris-stacker-ring', 'sorcha-drop-earrings', 'maja-layered-necklace', 'midnight-muse-necklace',
    'mirembe-bangle', 'radiant-heart-choker', 'balloon-letter-necklace', 'liv-bangle',
    'golden-twist-ring', 'solveig-bangle-bracelet', 'wilhelmina-earrings', 'tindra-bangle',
    'aegis-knot-bracelet', 'heartscape-necklace', 'anais-layered-ring', 'sunburst-pendant-necklace',
    'legacy-link-choker-necklace', 'noa-link-bracelet', 'diamond-teardrop-earrings', 'marquise-cuff-bracelet',
    'wren-clover-necklace', 'junia-drop-hoop-earrings',
  ];

  /* ── State ── */
  let selectedProducts = new Array(BUNDLE_SIZE).fill(null);
  /* Active category tab. The default comes from the section's "Default view"
     setting (BP_CONFIG.defaultTab) so the pill order, the server's pre-rendered
     card set and this starting value can never disagree. 'all'/'just-dropped'
     both show every product; they differ only in sort order. */
  let currentCategory  = (window.BP_CONFIG && window.BP_CONFIG.defaultTab) || 'all';
  let currentColor     = 'all';   // active color filter; 'all' shows every product

  /* ── DOM refs ── */
  const section = document.getElementById('bundle-picker') || document.querySelector('.bp-section');
  if (!section) {
    console.warn('[bundle-picker] Could not find the picker container (#bundle-picker or .bp-section) on this page. The Bundle Picker section may not be added to this template, or the section markup is missing its id. Buttons will not work until that is fixed.');
    return;
  }

  const trayEl      = document.getElementById('bp-tray');
  const slotsEl     = document.getElementById('bp-slots');
  const countNumEl  = document.getElementById('bp-count-num');

  /* Touch devices: tap a filled slot circle to remove that piece (whole circle is the target;
     no ✕ shown). Desktop uses the hover ✕ instead. Delegated on the container so it survives
     slot re-renders and never stacks duplicate listeners. removeFromSlot is hoisted below. */
  if (slotsEl) {
    slotsEl.addEventListener('click', (e) => {
      if (!window.matchMedia('(hover: none)').matches) return;   // desktop → use the ✕
      const slot = e.target.closest('.bp-slot');
      if (!slot || !slot.classList.contains('filled')) return;
      const idx = Array.prototype.indexOf.call(slotsEl.children, slot);
      if (idx > -1) removeFromSlot(idx);
    });
  }
  const countMsgEl  = document.getElementById('bp-count-msg');
  const progressBar = document.getElementById('bp-progress-bar');
  const checkoutBtn = document.getElementById('bp-checkout-btn');
  const errorEl     = document.getElementById('bp-error');
  const sortSelect  = document.getElementById('bp-sort');
  const tabs        = section.querySelectorAll('#bp-tabs .bp-tab');
  const colorTabs   = section.querySelectorAll('#bp-color-tabs .bp-color-tab');
  const panels      = section.querySelectorAll('.bp-panel');

  /* ── Normalize Shopify image URLs ── */
  function normalizeImgSrc(src) {
    if (!src) return '';
    var clean = String(src).replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|master|\d+x\d*)(?=\.[a-z]{3,4}(\?|$))/i, '');
    if (clean.startsWith('//')) clean = 'https:' + clean;
    return clean;
  }

  /* Return a CDN-resized version of a Shopify image URL (avoids loading
     full-resolution originals in the quick-view gallery). */
  function qvSized(src, w) {
    var u = normalizeImgSrc(src);
    if (!u) return u;
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  /* ── Pagination state + helper ──
     Each panel shows PER_PAGE cards; the rest are hidden via .bp-card-hidden
     and revealed by the Show More button. Re-applied on tab/sort/show-more. */
  const visibleCountMap  = new WeakMap();
  const originalOrderMap = new WeakMap();

  /* A card is visible when it matches BOTH the active category tab and the
     active color filter. 'all' / 'just-dropped' impose no category limit. */
  function isVisible(card) {
    var catOk = currentCategory === 'all' ||
                currentCategory === 'just-dropped' ||
                card.dataset.category === currentCategory;
    if (!catOk) return false;
    if (currentColor === 'all') return true;
    var colors = (card.dataset.colors || '').split(' ');
    return colors.indexOf(currentColor) > -1;
  }

  /* Map a color key to the matching card data-attribute (dataset is camelCased). */
  function colorImgKey(color) {
    switch (color) {
      case 'silver':    return 'colorImgSilver';
      case 'rose-gold': return 'colorImgRoseGold';
      case 'two-tone':  return 'colorImgTwoTone';
      default:          return null;   // gold uses the default (gold) hero
    }
  }

  /* Swap each card's hero image to the active color's image where one exists;
     otherwise (and for 'all'/'gold') restore the product's default hero. */
  function applyColorImages() {
    var key = colorImgKey(currentColor);
    section.querySelectorAll('.bp-card-wrapper .bp-card-img--primary').forEach(function (img) {
      if (img.dataset.defaultSrc == null) img.dataset.defaultSrc = img.getAttribute('src') || '';
      var src = img.dataset.defaultSrc;
      if (key) {
        var card = img.closest('.bp-card-wrapper');
        if (card && card.dataset[key]) src = card.dataset[key];
      }
      if (img.getAttribute('src') !== src) img.setAttribute('src', src);
    });
  }

  /* 'Just Dropped' sorts the grid newest-first; any other category restores
     the default (best-seller) order snapshotted after applyDefaultOrder(). */
  /* Rank map for the "Just Dropped" order, built from the newest-first collection
     the section renders (window.BP_NEWEST_ORDER). Using the SAME list the server
     used to decide which cards get a pre-rendered body means the cards on screen
     at first paint are exactly the ones this sort floats to the top — nothing has
     to be rebuilt in the browser. Falls back to the created-date sort when the
     list is absent (collection unset/empty). */
  var NEWEST_RANK = null;
  if (Array.isArray(window.BP_NEWEST_ORDER) && window.BP_NEWEST_ORDER.length) {
    NEWEST_RANK = new Map(window.BP_NEWEST_ORDER.map(function (h, i) { return [h, i]; }));
  }

  function applyCategorySort() {
    var grid = section.querySelector('.bp-panel .bp-grid');
    if (!grid) return;
    if (currentCategory === 'just-dropped') {
      var cards = Array.from(grid.querySelectorAll('.bp-card-wrapper'));
      cards.sort(function (a, b) {
        if (NEWEST_RANK) {
          var ra = NEWEST_RANK.has(a.dataset.handle) ? NEWEST_RANK.get(a.dataset.handle) : Infinity;
          var rb = NEWEST_RANK.has(b.dataset.handle) ? NEWEST_RANK.get(b.dataset.handle) : Infinity;
          if (ra !== rb) return ra < rb ? -1 : 1;
          /* both unranked → fall through to the date sort below */
        }
        return (parseInt(b.dataset.created || 0, 10) - parseInt(a.dataset.created || 0, 10));
      });
      cards.forEach(function (c) { grid.appendChild(c); });
    } else {
      var original = originalOrderMap.get(grid);
      if (original) original.forEach(function (c) { grid.appendChild(c); });
    }
  }

  /* ── Lazy card rendering (mobile performance) ──
     Off-screen cards ship from the server as lightweight "shells": just the
     .bp-card-wrapper with its data attributes (enough to filter/sort/colour the
     whole catalogue) but no image-heavy .bp-card body. materializeCard() builds
     that body the first time a card is actually shown. This keeps the initial
     HTML/DOM small without changing any filter, sort, colour or quick-view
     behaviour. Idempotent: server-rendered cards already contain .bp-card and
     are skipped. */
  function bpEscape(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  /* Source URL for a card's primary slide, honouring the active colour filter. */
  function primarySrcFor(card, imgs) {
    var key = colorImgKey(currentColor);
    if (key && card.dataset[key]) return card.dataset[key];
    return (imgs && imgs[0]) || '';
  }

  function materializeCard(card) {
    if (!card || card.querySelector('.bp-card')) return;   // already has a body

    var title     = card.dataset.title || '';
    var handle    = card.dataset.handle || '';
    var available = card.dataset.available === 'true';
    var imgs      = (card.dataset.imgs || '').split('|').filter(Boolean);
    var tEsc      = bpEscape(title);

    // Touch devices eagerly load only the hero image — the 2nd is the DESKTOP
    // hover image; on mobile it joins the deferred slides and loads on first
    // swipe (initCardGallery). Halves the image work on Show More.
    var eagerImgs = (window.matchMedia && matchMedia('(hover: none)').matches) ? 1 : 2;

    var h = '<div class="bp-card"><div class="bp-card-image-wrap">';
    if (imgs.length) {
      h += '<div class="bp-card-track" data-bp-track>';
      for (var i = 0; i < imgs.length; i++) {
        var cls = 'bp-card-img bp-card-slide' +
                  (i === 0 ? ' bp-card-img--primary' : (i === 1 ? ' bp-card-img--secondary' : ''));
        var srcAttr = i < eagerImgs
          ? 'src="' + bpEscape(i === 0 ? primarySrcFor(card, imgs) : imgs[i]) + '"'
          : 'data-bp-src="' + bpEscape(imgs[i]) + '"';
        // Hero loads eager + high priority — this card is being shown RIGHT NOW;
        // lazy gave it LOW fetch priority, so Show More tiles sat blank while
        // cold-cache CDN images trickled in. The desktop hover image (i=1) is
        // eager at NORMAL priority — as lazy it got starved behind the
        // high-priority heroes + prefetches, so hover showed a blank.
        var loadAttr = i === 0 ? 'loading="eager" fetchpriority="high"'
                     : (i < eagerImgs ? 'loading="eager"' : 'loading="lazy"');
        h += '<img class="' + cls + '" ' + srcAttr + ' alt="' + tEsc +
             '" ' + loadAttr + ' decoding="async" width="400" height="400">';
      }
      h += '</div>';
      if (imgs.length > 1) {
        h += '<div class="bp-card-dots" data-bp-dots aria-hidden="true">';
        for (var d = 0; d < imgs.length; d++) {
          h += '<span class="bp-card-dot' + (d === 0 ? ' active' : '') + '" data-bp-dot="' + d + '"></span>';
        }
        h += '</div>';
      }
    } else {
      h += '<div class="bp-card-img bp-card-img--placeholder"></div>';
    }
    if (!available) h += '<span class="bp-card-badge bp-card-badge--sold-out">Sold Out</span>';
    h += '<div class="bp-card-check" style="display:none;"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg></div>';
    h += '<button class="bp-card-qv-btn" data-handle="' + bpEscape(handle) + '" aria-label="Quick view ' + tEsc + '"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg><span>Quick View</span></button>';
    h += '</div><div class="bp-card-body"><h3 class="bp-card-title">' + tEsc + '</h3><p class="bp-card-included" style="display:none;">Included</p></div><div class="bp-card-footer">';
    if (available) {
      h += '<button class="bp-card-add-btn" aria-label="Add ' + tEsc + ' to bundle">Add<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 5v14M5 12h14"/></svg></button><div class="bp-card-qty" style="display:none;"><button class="bp-card-qty-btn bp-card-qty-minus" aria-label="Remove one"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M5 12h14"/></svg></button><span class="bp-card-qty-num">1</span><button class="bp-card-qty-btn bp-card-qty-plus" aria-label="Add one more"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 5v14M5 12h14"/></svg></button></div>';
    } else {
      h += '<button class="bp-card-add-btn bp-card-add-btn--sold-out" disabled>Sold Out</button>';
    }
    h += '</div></div>';

    card.insertAdjacentHTML('afterbegin', h);

    // Remember the default (gold/first) hero so applyColorImages() can restore
    // it when the colour filter changes.
    var primaryImg = card.querySelector('.bp-card-img--primary');
    if (primaryImg && imgs.length) primaryImg.dataset.defaultSrc = imgs[0];

    // Restore any in-progress bundle selection state and wire the swipe gallery.
    updateCardQty(card);
    var track = card.querySelector('.bp-card-track');
    if (track) initCardGallery(track);
  }

  /* Build card bodies a few per frame instead of all at once — synchronously
     materializing a whole Show More batch (20 cards) froze mobile for seconds.
     Cards get a .bp-card-pending placeholder until their body is built. */
  const bpBuildQueue = [];
  let bpBuildRunning = false;
  /* rAF NEVER fires while a tab is hidden (background tab, prerender, or a
     browser that isn't compositing), which would strand queued cards as empty
     shells until the tab is looked at. A timer runs the same step function, so
     the queue always drains; whichever callback lands first wins and the other
     is cancelled. */
  let bpRafId = null;
  let bpTimerId = null;
  function bpClearScheduled() {
    if (bpRafId !== null) { cancelAnimationFrame(bpRafId); bpRafId = null; }
    if (bpTimerId !== null) { clearTimeout(bpTimerId); bpTimerId = null; }
  }
  function bpSchedule(step) {
    bpClearScheduled();
    bpRafId = requestAnimationFrame(function () { bpClearScheduled(); step(); });
    bpTimerId = setTimeout(function () { bpClearScheduled(); step(); }, 100);
  }
  function bpDrainQueue() {
    if (bpBuildRunning || !bpBuildQueue.length) return;
    bpBuildRunning = true;
    bpSchedule(function step() {
      // try/finally: ONE throwing card must never wedge the queue — without it
      // bpBuildRunning stays true forever and every later card stays blank.
      try {
        let budget = 5;   // ~5 cards per frame keeps taps + scrolling responsive
        while (budget-- > 0 && bpBuildQueue.length) {
          const c = bpBuildQueue.shift();
          try {
            materializeCard(c);
          } catch (err) {
            console.error('[bundle-picker] card build failed:',
              c && c.dataset ? c.dataset.handle : c, err);
          }
          c.classList.remove('bp-card-pending');
        }
      } finally {
        if (bpBuildQueue.length) bpSchedule(step);
        else bpBuildRunning = false;
      }
    });
  }
  function queueMaterialize(card) {
    if (!card || card.querySelector('.bp-card')) return;          // already built
    if (card.classList.contains('bp-card-pending')) return;      // already queued
    card.classList.add('bp-card-pending');
    bpBuildQueue.push(card);
    bpDrainQueue();
  }

  /* Warm upcoming pages' hero images in the browser's idle time so a Show More
     click reveals tiles that are already in cache (and the CDN edge is warm —
     cold 400px crops measured 200-560ms each vs 32ms warm). Warms up to THREE
     pages ahead (re-warmed on every reveal, so fast tappers stay ahead — one
     page wasn't enough once mobile dropped to 12/page), in small chunks so the
     warm-up never competes with the batch being revealed right now. */
  const bpWarmedHeroes = new Set();
  function prefetchHeroes(cards) {
    if (!cards.length) return;
    const conn = navigator.connection || {};
    if (conn.saveData) cards = cards.slice(0, PER_PAGE);   // data saver: 1 page only
    const queue = [];
    cards.forEach(function (card) {
      const imgs = (card.dataset.imgs || '').split('|').filter(Boolean);
      const src = primarySrcFor(card, imgs);
      if (src && !bpWarmedHeroes.has(src)) {
        bpWarmedHeroes.add(src);
        queue.push(src);
      }
    });
    if (!queue.length) return;
    const CHUNK = 8;
    function go() {
      queue.splice(0, CHUNK).forEach(function (src) {
        const im = new Image();
        im.decoding = 'async';
        im.fetchPriority = 'low';
        im.src = src;
      });
      if (queue.length) schedule();
    }
    function schedule() {
      if ('requestIdleCallback' in window) requestIdleCallback(go, { timeout: 2500 });
      else setTimeout(go, 600);
    }
    schedule();
  }

  function applyPagination(panel) {
    const grid = panel.querySelector('.bp-grid');
    const moreBtn = panel.querySelector('.bp-show-more-btn');
    if (!grid) return;
    const cards = Array.from(grid.querySelectorAll('.bp-card-wrapper'));
    const visible = visibleCountMap.get(panel) || PER_PAGE;

    // Show the first `visible` cards matching BOTH the active category and the
    // active color; hide the rest (non-matching + those beyond the page limit).
    let shownInCat = 0;
    let matchCount = 0;
    const nextPage = [];   // next THREE pages of hidden matches → hero prefetch
    cards.forEach((card) => {
      if (!isVisible(card)) {
        card.classList.add('bp-card-hidden');
        return;
      }
      matchCount++;
      const hide = shownInCat >= visible;
      card.classList.toggle('bp-card-hidden', hide);
      if (!hide) queueMaterialize(card);   // build the body only for cards we show
      else if (nextPage.length < PER_PAGE * 3) nextPage.push(card);
      shownInCat++;
    });

    // Watchdog: if a previous drain died mid-run (or a frame was missed),
    // restart it — queued cards must never sit blank.
    bpDrainQueue();

    prefetchHeroes(nextPage);

    if (moreBtn) {
      if (matchCount <= visible) {
        moreBtn.style.display = 'none';
      } else {
        moreBtn.style.display = '';
        const nextBatch = Math.min(matchCount - visible, PER_PAGE);
        moreBtn.textContent = `Show More (${nextBatch})`;
      }
    }
  }

  /* ── Tabs ──
     One grid holds every product (tagged with data-category). Tabs no longer
     swap panels — they set the active category and re-filter the single grid. */
  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      tabs.forEach(t => t.classList.remove('active'));
      tab.classList.add('active');
      currentCategory = tab.dataset.tab || 'all';
      applyCategorySort();   // newest-first for 'just-dropped', default otherwise
      applyColorImages();    // keep any active color swap after re-ordering
      const panel = section.querySelector('.bp-panel');
      if (panel) {
        // Reset pagination so switching categories always starts at page 1
        visibleCountMap.set(panel, PER_PAGE);
        applyPagination(panel);
      }
    });
  });

  /* ── Color filter (second row) ── */
  colorTabs.forEach(tab => {
    tab.addEventListener('click', () => {
      colorTabs.forEach(t => t.classList.remove('active'));
      tab.classList.add('active');
      currentColor = tab.dataset.color || 'all';
      applyColorImages();
      const panel = section.querySelector('.bp-panel');
      if (panel) {
        visibleCountMap.set(panel, PER_PAGE);
        applyPagination(panel);
      }
    });
  });

  /* ── Default ordering: exact best-seller sequence ──
     Reorder cards to match DEFAULT_ORDER (the source store's best-seller order,
     top to bottom). Listed handles come first in that exact order; anything not
     listed keeps its original relative order, after. */
  function applyDefaultOrder() {
    if (!DEFAULT_ORDER.length) return;
    const rank = new Map(DEFAULT_ORDER.map((h, i) => [h, i]));
    section.querySelectorAll('.bp-panel .bp-grid').forEach(grid => {
      const cards = Array.from(grid.querySelectorAll('.bp-card-wrapper'));
      cards.sort((a, b) => {
        const ra = rank.has(a.dataset.handle) ? rank.get(a.dataset.handle) : Infinity;
        const rb = rank.has(b.dataset.handle) ? rank.get(b.dataset.handle) : Infinity;
        return ra === rb ? 0 : (ra < rb ? -1 : 1);  // NaN-safe; stable for unranked
      });
      cards.forEach(c => grid.appendChild(c));
    });
  }
  applyDefaultOrder();

  /* ── Sort (Featured / Best Selling / price / name) ──
     Snapshot the (now reordered) Liquid order per grid so the "Featured"
     option can always restore it. */
  panels.forEach(panel => {
    const grid = panel.querySelector('.bp-grid');
    if (!grid) return;
    originalOrderMap.set(grid, Array.from(grid.querySelectorAll('.bp-card-wrapper')));
  });

  /* Apply the default view's sort. Only needed when the default is NOT 'all' —
     'all' already IS the snapshotted order. Runs after the snapshot above, so
     "All" and the category tabs still restore the best-seller/priority order. */
  if (currentCategory !== 'all') applyCategorySort();

  if (sortSelect) sortSelect.addEventListener('change', () => {
    const val = sortSelect.value;
    panels.forEach(panel => {
      const grid = panel.querySelector('.bp-grid');
      if (!grid) return;

      if (val === 'default') {
        const original = originalOrderMap.get(grid);
        if (original) original.forEach(c => grid.appendChild(c));
      } else {
        const cards = Array.from(grid.querySelectorAll('.bp-card-wrapper'));
        cards.sort((a, b) => {
          const pa = parseFloat(a.dataset.priceRaw || 0);
          const pb = parseFloat(b.dataset.priceRaw || 0);
          const ta = (a.dataset.title || '').toLowerCase();
          const tb = (b.dataset.title || '').toLowerCase();
          const ra = parseInt(a.dataset.featuredRank || 0);
          const rb = parseInt(b.dataset.featuredRank || 0);
          if (val === 'best-selling') {
            if (ra === 0 && rb === 0) return 0;
            if (ra === 0) return 1;
            if (rb === 0) return -1;
            return ra - rb;
          }
          if (val === 'price-asc')  return pa - pb;
          if (val === 'price-desc') return pb - pa;
          if (val === 'title-asc')  return ta.localeCompare(tb);
          if (val === 'title-desc') return tb.localeCompare(ta);
          return 0;
        });
        cards.forEach(c => grid.appendChild(c));
      }

      // Reset pagination so the new top-N shows from page 1
      visibleCountMap.set(panel, PER_PAGE);
      applyPagination(panel);
    });
  });

  /* ── Show More ── */
  section.addEventListener('click', (e) => {
    const moreBtn = e.target.closest('.bp-show-more-btn');
    if (!moreBtn) return;
    const panel = moreBtn.closest('.bp-panel');
    if (!panel) return;
    const current = visibleCountMap.get(panel) || PER_PAGE;
    visibleCountMap.set(panel, current + PER_PAGE);
    applyPagination(panel);
  });

  /* ── Initial pagination pass ── */
  panels.forEach(panel => {
    visibleCountMap.set(panel, PER_PAGE);
    applyPagination(panel);
  });

  /* ── Session persistence (pre-checkout) ──
     The cart only knows the bundle after a CHECKOUT click — a refresh mid-build
     used to lose partial picks. Snapshot the selection on every change
     (updateTrayUI is the choke point all mutations pass through) and restore
     synchronously at boot. Precedence: session snapshot (latest picker state
     in this tab) → cart bundle (new tab / next day) → empty. */
  let bpStateReady = false;   // block saves until the initial restore has run
  function saveSelection() {
    if (!bpStateReady) return;
    try {
      sessionStorage.setItem('bp-selection', JSON.stringify({
        v: 1,
        size: BUNDLE_SIZE,   // snapshot is only valid for the same offer size
        items: selectedProducts.filter(Boolean)
      }));
    } catch (e) { /* storage unavailable (private mode etc.) — non-fatal */ }
  }
  function restoreFromSession() {
    try {
      const raw = sessionStorage.getItem('bp-selection');
      if (!raw) return false;
      const snap = JSON.parse(raw);
      if (!snap || snap.v !== 1 || snap.size !== BUNDLE_SIZE ||
          !Array.isArray(snap.items) || !snap.items.length) return false;
      snap.items.slice(0, BUNDLE_SIZE).forEach(function (p, i) {
        if (p && p.variantId) selectedProducts[i] = p;
      });
      return selectedProducts.filter(Boolean).length > 0;
    } catch (e) { return false; }
  }
  /* Repaint qty badges on already-built cards after a restore (shells pick the
     state up automatically when they materialize). */
  function repaintSelectedCards() {
    section.querySelectorAll('.bp-card-wrapper').forEach(function (w) {
      if (w.querySelector('.bp-card')) updateCardQty(w);
    });
  }

  /* ── Sticky tray UI ── */
  function updateTrayUI() {
    const count = selectedProducts.filter(Boolean).length;
    if (countNumEl) countNumEl.textContent = count;

    // Only show the floating tray once at least one item is in the bundle
    if (trayEl) trayEl.classList.toggle('bp-tray--visible', count >= 1);

    // Progress bar
    if (progressBar) {
      const pct = (count / BUNDLE_SIZE) * 100;
      progressBar.style.width = pct + '%';
      progressBar.classList.toggle('complete', count === BUNDLE_SIZE);
    }

    // Label
    if (countMsgEl) {
      countMsgEl.innerHTML = `Your Bundle: <strong>${count} of ${BUNDLE_SIZE}</strong> selected`;
    }

    // Button text
    if (count === BUNDLE_SIZE) {
      checkoutBtn.textContent = 'CHECKOUT';
      checkoutBtn.disabled = false;
      checkoutBtn.classList.add('active');
    } else {
      checkoutBtn.textContent = `${count} OF ${BUNDLE_SIZE} SELECTED`;
      checkoutBtn.disabled = true;
      checkoutBtn.classList.remove('active');
    }

    const slots = slotsEl.querySelectorAll('.bp-slot');
    slots.forEach((slot, i) => {
      const p = selectedProducts[i];
      slot.innerHTML = '';
      if (p) {
        slot.classList.add('filled');
        slot.classList.remove('empty');
        const img = document.createElement('img');
        img.src = p.image;
        img.alt = p.title;
        const removeBtn = document.createElement('button');
        removeBtn.className = 'bp-slot-remove';
        removeBtn.innerHTML = '&#x2715;';
        removeBtn.setAttribute('aria-label', `Remove ${p.title}`);
        removeBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          removeFromSlot(i);
        });
        slot.appendChild(img);
        slot.appendChild(removeBtn);
      } else {
        slot.classList.remove('filled');
        slot.classList.add('empty');
        slot.innerHTML = '<span class="bp-slot-plus">+</span>';
      }
    });

    saveSelection();   // persist on every state change (no-op until boot restore ran)
  }

  /* ── Get quantity of a specific variantId in selection ── */
  function getVariantQty(variantId) {
    return selectedProducts.filter(p => p && p.variantId === String(variantId)).length;
  }


  /* ── Meta Pixel helpers ──
     Fire standard Meta (Facebook) Pixel events. No-op (and never throws)
     if the pixel isn't on the page, so this is safe even if fbq is missing. */
  function bpPriceToNumber(p) {
    if (typeof p === 'number') return p;
    if (!p) return 0;
    var n = parseFloat(String(p).replace(/[^0-9.]/g, ''));
    return isNaN(n) ? 0 : n;
  }
  function bpTrackPixel(eventName, data) {
    if (typeof window.fbq === 'function') {
      try { window.fbq('track', eventName, data); }
      catch (e) { console.error('[bundle-picker] fbq ' + eventName + ' failed:', e); }
    }
  }

  /* ── Add to Selection ── */
  function addToSelection(productData, cardEl, skipVariantCheck) {
    const count = selectedProducts.filter(Boolean).length;
    if (count >= BUNDLE_SIZE) {
      showError(`You can only select ${BUNDLE_SIZE} items. Remove one to swap.`);
      return false;
    }
    hideError();
    const firstEmpty = selectedProducts.findIndex(p => p === null);
    selectedProducts[firstEmpty] = productData;

    if (cardEl) updateCardQty(cardEl);
    updateTrayUI();

    // Meta Pixel: fire AddToCart each time an item is added to the bundle.
    // Value = the piece's EFFECTIVE price (offer total / bundle size), not its
    // retail price — retail summed to ~$250 of AddToCart value per $95 bundle.
    bpTrackPixel('AddToCart', {
      content_ids:  [productData.variantId],
      content_type: 'product',
      content_name: productData.title,
      value:        Math.round(BUNDLE_PRICE / BUNDLE_SIZE) / 100,
      currency:     'USD'
    });

    // Celebration hook — dispatch on EVERY successful add so bundle-celebrate.js beeps/
    // animates regardless of timing. The single-variant path adds only AFTER an async
    // product fetch (lands past the old click+100ms window), which is why the sound was
    // missing for no-/single-variant items; an event fixes all paths at one choke point.
    document.dispatchEvent(new CustomEvent('bundle:added', {
      detail: {
        image: productData.image,
        cardEl: cardEl || null,
        count:  selectedProducts.filter(Boolean).length
      }
    }));

    return true;
  }

  /* ── Remove one instance of a variant from selection ── */
  function removeOneFromSelection(variantId, wrapper) {
    const idx = selectedProducts.findIndex(p => p && p.variantId === String(variantId));
    if (idx === -1) return;
    selectedProducts[idx] = null;

    const remaining = selectedProducts.filter(Boolean);
    selectedProducts = [...remaining, ...new Array(BUNDLE_SIZE - remaining.length).fill(null)];

    if (wrapper) updateCardQty(wrapper);

    // Update plus buttons on all cards since total count changed
    section.querySelectorAll('.bp-card-qty-btn:last-child').forEach(btn => {
      btn.disabled = selectedProducts.filter(Boolean).length >= BUNDLE_SIZE;
    });

    hideError();
    updateTrayUI();
  }

  /* ── Remove from Slot (tray) ── */
  function removeFromSlot(index) {
    const removed = selectedProducts[index];
    if (!removed) return;
    selectedProducts[index] = null;

    const remaining = selectedProducts.filter(Boolean);
    selectedProducts = [...remaining, ...new Array(BUNDLE_SIZE - remaining.length).fill(null)];

    // Update card UI for removed product
    section.querySelectorAll('.bp-card-wrapper').forEach(wrapper => {
      if (wrapper.dataset.productId === String(removed.productId)) {
        updateCardQty(wrapper);
      }
    });

    hideError();
    updateTrayUI();
  }

  /* ══════════════════════════════════════════════════
     INLINE VARIANT PICKER (shown on the card itself)
  ══════════════════════════════════════════════════ */

  let activeInlineWrapper = null;
  let inlineProduct       = null;
  let inlineSelectedOpts  = {};
  let inlineVariant       = null;

  // bp-exclude:<option value> product tags hide that option value inside the builder only (e.g. "bp-exclude:Set" keeps a
  // ring SET out of the 6-for-95 picks while the singles stay pickable). Applied to every /products/<handle>.js load:
  // variants carrying the value are dropped and each option's value list is rebuilt from what is left. 2026-10-19.
  function bpApplyExclusions(product) {
    if (!product || !product.variants) return product;
    var tags = Array.isArray(product.tags) ? product.tags : String(product.tags || '').split(',');
    var ex = tags.map(function (t) { return String(t).trim(); })
      .filter(function (t) { return /^bp-exclude:/i.test(t); })
      .map(function (t) { return t.slice(11).trim().toLowerCase(); });
    if (!ex.length) return product;
    var n = (product.options || []).length;
    product.variants = product.variants.filter(function (v) {
      for (var i = 1; i <= n; i++) { if (ex.indexOf(String(v['option' + i] || '').toLowerCase()) > -1) return false; }
      return true;
    });
    (product.options || []).forEach(function (o, idx) {
      var seen = []; product.variants.forEach(function (v) { var val = v['option' + (idx + 1)]; if (val != null && seen.indexOf(val) < 0) seen.push(val); });
      o.values = seen;
    });
    return product;
  }

  function closeInlineVariants(wrapper) {
    if (!wrapper) return;
    const panel = wrapper.querySelector('.bp-inline-variants');
    if (panel) panel.remove();
    if (activeInlineWrapper === wrapper) activeInlineWrapper = null;
  }

  function closeAllInlineVariants() {
    section.querySelectorAll('.bp-inline-variants').forEach(el => el.remove());
    activeInlineWrapper = null;
  }

  /* ── Color-swatch helpers ──────────────────────────────────────────
     Render color/finish options as swatches instead of text. Other
     option types (Size, Ring size, Letter…) stay as text buttons. */
  const BP_SWATCH_COLORS = {
    'gold':        'linear-gradient(135deg,#f6e9a8,#d4af37 55%,#b8860b)',
    'yellow gold': 'linear-gradient(135deg,#f6e9a8,#d4af37 55%,#b8860b)',
    'silver':      'linear-gradient(135deg,#f7f7f7,#c4c4c4 55%,#9a9a9a)',
    'white gold':  'linear-gradient(135deg,#fcfcfc,#dcdcdc 55%,#bcbcbc)',
    'platinum':    'linear-gradient(135deg,#fcfcfc,#dcdcdc 55%,#bcbcbc)',
    'rose gold':   'linear-gradient(135deg,#f8d8c8,#e0a899 55%,#b76e79)',
    'rose':        'linear-gradient(135deg,#f8d8c8,#e0a899 55%,#b76e79)',
    'rosegold':    'linear-gradient(135deg,#f8d8c8,#e0a899 55%,#b76e79)',
    'black':       'linear-gradient(135deg,#4a4a4a,#111)',
    'gunmetal':    'linear-gradient(135deg,#5a5a5a,#2b2b2b)',
    'white':       '#fafafa',
    'pearl':       'linear-gradient(135deg,#ffffff,#efe9df)',
    'two tone':    'linear-gradient(135deg,#f6e9a8 0%,#d4af37 48%,#c4c4c4 52%,#9a9a9a 100%)',
    'two-tone':    'linear-gradient(135deg,#f6e9a8 0%,#d4af37 48%,#c4c4c4 52%,#9a9a9a 100%)',
    // gem colours (for "Gem Color" / stone options)
    'ruby':        'linear-gradient(135deg,#e3536b,#9b111e)',
    'emerald':     'linear-gradient(135deg,#7fd1a3,#0b6b3a)',
    'sapphire':    'linear-gradient(135deg,#6aa3e0,#0f3e8a)',
    'citrine':     'linear-gradient(135deg,#ffe08a,#e0a600)',
    'aquamarine':  'linear-gradient(135deg,#cdeef0,#5fb6c4)',
    'amethyst':    'linear-gradient(135deg,#cda8e6,#7b3fa0)',
    'topaz':       'linear-gradient(135deg,#bfe3f0,#4aa3c4)',
    'garnet':      'linear-gradient(135deg,#c1485c,#6e0f1a)',
    'pink':        'linear-gradient(135deg,#ffd1e0,#e06a98)',
    'green':       'linear-gradient(135deg,#9bd9b0,#2f8f55)',
    'blue':        'linear-gradient(135deg,#a9c9ef,#3a6fc4)',
    'clear':       'linear-gradient(135deg,#ffffff,#e6e6e6)',
    'crystal':     'linear-gradient(135deg,#ffffff,#e6e6e6)'
  };

  function bpIsColorOption(name) {
    return /colou?r|finish|metal|tone|material|plating|stone|gem/i.test(name || '');
  }

  // Gradients for swatch values — metals + gems + birthstone colour words.
  const BP_GRAD = {
    gold:'linear-gradient(135deg,#f6e9a8,#d4af37 55%,#b8860b)',
    silver:'linear-gradient(135deg,#f7f7f7,#c4c4c4 55%,#9a9a9a)',
    whitegold:'linear-gradient(135deg,#fcfcfc,#dcdcdc 55%,#bcbcbc)',
    rosegold:'linear-gradient(135deg,#f8d8c8,#e0a899 55%,#b76e79)',
    twotone:'linear-gradient(135deg,#f6e9a8 0%,#d4af37 48%,#c4c4c4 52%,#9a9a9a 100%)',
    black:'linear-gradient(135deg,#5a5a5a,#1a1a1a)',
    pearl:'linear-gradient(135deg,#ffffff,#efe9df)',
    red:'linear-gradient(135deg,#ff7a7a,#c0392b)',
    pink:'linear-gradient(135deg,#ffd1e0,#e06a98)',
    purple:'linear-gradient(135deg,#cda8e6,#7b3fa0)',
    blue:'linear-gradient(135deg,#7fb0ec,#2f5fb0)',
    lightblue:'linear-gradient(135deg,#cfe4fb,#7fb0ec)',
    aqua:'linear-gradient(135deg,#cdeef0,#5fb6c4)',
    green:'linear-gradient(135deg,#8fd6a6,#2f8f55)',
    lightgreen:'linear-gradient(135deg,#d6eaa3,#8bc34a)',
    yellow:'linear-gradient(135deg,#fff3a0,#f3d23b)',
    orange:'linear-gradient(135deg,#ffcf9e,#e8893b)',
    clear:'linear-gradient(135deg,#ffffff,#e3e3e3)',
    brown:'linear-gradient(135deg,#b08968,#6f4e37)',
    rainbow:'linear-gradient(135deg,#e05a5a,#e8a13b 25%,#e8d93b 45%,#57b86a 65%,#4a78c4 82%,#8b5fb0)'
  };
  // Map an option VALUE to a swatch gradient. Store-agnostic: AL's clean values ("Gold"),
  // Avaria's karat-prefixed ("18k Yellow Gold", "Two Tone"), and birthstone "Month - Colour".
  function bpSwatchColor(val) {
    let s = String(val || '').trim().toLowerCase();
    if (!s) return null;
    // birthstone / "Month - Colour" → use the colour descriptor after the dash
    if (s.indexOf(' - ') !== -1) s = s.split(' - ').pop().trim();
    // strip karat / purity prefixes
    s = s.replace(/\b(\d{1,3}\s*k|s?925|sterling|solid)\b/g, ' ').replace(/\s+/g, ' ').trim();
    if (/rainbow/.test(s)) return BP_GRAD.rainbow;
    if (/two[\s-]?tone|2[\s-]?tone|tri[\s-]?tone|multi/.test(s)) return BP_GRAD.twotone;
    // metals containing "gold" (rose/white before plain gold)
    if (/gold/.test(s)) {
      if (/rose/.test(s))  return BP_GRAD.rosegold;
      if (/white/.test(s)) return BP_GRAD.whitegold;
      return BP_GRAD.gold;
    }
    if (/silver/.test(s))           return BP_GRAD.silver;
    if (/platinum/.test(s))         return BP_GRAD.whitegold;
    if (/gun|graphite|charcoal/.test(s)) return BP_GRAD.black;
    // gem / birthstone colour words (incl. Swarovski names + Avaria enamel/resin names)
    if (/ruby|garnet|siam|cherry|\bred\b|scarlet/.test(s))          return BP_GRAD.red;
    if (/rose|\bpink\b|blush|berry|sakura|fuchsia|magenta/.test(s)) return BP_GRAD.pink;
    if (/amethyst|alexandrite|violet|purple|lavender|lilac|grape|plum/.test(s)) return BP_GRAD.purple;
    if (/peridot|mint|lime|citrus/.test(s))                         return BP_GRAD.lightgreen;
    if (/emerald|jade|viridian|evergreen|forest|\bgreen\b/.test(s)) return BP_GRAD.green;
    if (/aquamarine|\baqua\b|turquoise|teal|ocean|mist/.test(s))    return BP_GRAD.aqua;
    if (/light\s*sapphire|light\s*blue|\bsky\b/.test(s)) return BP_GRAD.lightblue;
    if (/sapphire|\bblue\b|topaz/.test(s))            return BP_GRAD.blue;
    if (/citrine|jonquil|\byellow\b|amber|lemon/.test(s)) return BP_GRAD.yellow;
    if (/\borange\b|coral|tangerine|peach/.test(s))   return BP_GRAD.orange;
    if (/cocoa|coffee|chocolate|mocha|\bbrown\b|taupe/.test(s)) return BP_GRAD.brown;
    if (/crystal|clear|diamond|marble|\bwhite\b/.test(s)) return BP_GRAD.clear;
    if (/black|onyx|ebony/.test(s))                   return BP_GRAD.black;
    if (/pearl|cream|ivory|beige/.test(s))            return BP_GRAD.pearl;
    return null;
  }

  // Is there an AVAILABLE variant with option[optIdx]==val, given the other selected options?
  function bpComboAvailable(product, optIdx, val, selected) {
    return (product.variants || []).some(function (v) {
      if (v.available === false) return false;
      if (v['option' + (optIdx + 1)] !== val) return false;
      for (var j = 0; j < (product.options || []).length; j++) {
        if (j === optIdx) continue;
        var sel = selected[j];
        if (sel != null && v['option' + (j + 1)] !== sel) return false;
      }
      return true;
    });
  }
  // Toggle the .bp-unavailable class on every option button in a container.
  function bpUpdateAvail(container, product, selected) {
    if (!container) return;
    container.querySelectorAll('[data-opt-idx]').forEach(function (btn) {
      var ok = bpComboAvailable(product, parseInt(btn.dataset.optIdx, 10), btn.dataset.optVal, selected);
      btn.classList.toggle('bp-unavailable', !ok);
    });
  }

  // First variant image matching a given option value (used as a swatch fallback).
  function bpVariantImageFor(product, optIdx, val) {
    const key = 'option' + (optIdx + 1);
    const v = (product.variants || []).find(
      v => v[key] === val && v.featured_image && v.featured_image.src
    );
    return v ? normalizeImgSrc(v.featured_image.src) : null;
  }

  async function openInlineVariants(wrapper) {
    if (activeInlineWrapper === wrapper) {
      closeInlineVariants(wrapper);
      return;
    }

    closeAllInlineVariants();
    activeInlineWrapper = wrapper;

    const handle = wrapper.dataset.handle;

    const loading = document.createElement('div');
    loading.className = 'bp-inline-variants';
    loading.innerHTML = '<p class="bp-inline-loading">Loading…</p>';
    wrapper.appendChild(loading);

    let product;
    try {
      const res = await fetch(`/products/${handle}.js`);
      if (!res.ok) throw new Error();
      product = bpApplyExclusions(await res.json());
    } catch (e) {
      loading.innerHTML = '<p class="bp-inline-loading">Could not load options.</p>';
      return;
    }

    inlineProduct      = product;
    inlineSelectedOpts = {};
    inlineVariant      = null;

    const hasRealOptions =
      product.options.length > 0 &&
      !(product.options.length === 1 && product.options[0].name === 'Title') &&
      !(product.variants.length === 1);

    // Single variant: skip popup, add instantly
    if (!hasRealOptions) {
      loading.remove();
      activeInlineWrapper = null;
      const v = product.variants[0];
      const image = normalizeImgSrc(
        (v.featured_image && v.featured_image.src)
          || (product.images && product.images[0] && product.images[0].src)
          || product.featured_image
          || wrapper.dataset.image
      );
      const productData = {
        productId: String(product.id),
        variantId: String(v.id),
        title:     product.title,
        price:     (v.price / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' }),
        image:     image,
        handle:    product.handle,
      };
      addToSelection(productData, wrapper);
      return;
    }

    // Multi-variant: show inline picker
    const panel = document.createElement('div');
    panel.className = 'bp-inline-variants';

    const closeBtn = document.createElement('button');
    closeBtn.className = 'bp-inline-close';
    closeBtn.innerHTML = '&#x2715;';
    closeBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      closeInlineVariants(wrapper);
    });
    panel.appendChild(closeBtn);

    product.options.forEach((option, idx) => {
      const uniqueValues = [...new Set(option.values)];

      // Only one possible value (e.g. Color: just "18k Yellow Gold"): pre-select
      // it and skip the group entirely — the customer only picks real choices.
      if (uniqueValues.length === 1) {
        inlineSelectedOpts[idx] = uniqueValues[0];
        return;
      }

      const group = document.createElement('div');
      group.className = 'bp-inline-option-group';

      const label = document.createElement('div');
      label.className = 'bp-inline-option-label';
      label.textContent = option.name;

      const valuesWrap = document.createElement('div');
      valuesWrap.className = 'bp-inline-option-values';

      const isColor = bpIsColorOption(option.name);
      uniqueValues.forEach(val => {
        const btn = document.createElement('button');
        btn.className = 'bp-inline-option-btn';
        btn.dataset.optIdx = idx;
        btn.dataset.optVal = val;

        // Color/finish options render as swatches: a known metallic gradient
        // if we recognize the name, otherwise the variant's product photo.
        let swatchBg = null;
        if (isColor) {
          swatchBg = bpSwatchColor(val);
          if (!swatchBg) {
            const img = bpVariantImageFor(product, idx, val);
            if (img) swatchBg = 'url("' + img + '")';
          }
        }

        if (swatchBg) {
          btn.classList.add('bp-inline-swatch');
          btn.style.background = swatchBg;
          btn.style.backgroundSize = 'cover';
          btn.style.backgroundPosition = 'center';
          btn.title = val;
          btn.setAttribute('aria-label', val);
        } else {
          btn.textContent = val;
        }

        btn.addEventListener('click', (e) => {
          e.stopPropagation();
          valuesWrap.querySelectorAll('.bp-inline-option-btn').forEach(b => b.classList.remove('active'));
          btn.classList.add('active');
          inlineSelectedOpts[idx] = val;
          if (isColor) label.textContent = option.name + ': ' + val;
          resolveInlineVariant(product, addBtnEl, wrapper);
          bpUpdateAvail(panel, product, inlineSelectedOpts);
        });
        valuesWrap.appendChild(btn);
      });

      group.appendChild(label);
      group.appendChild(valuesWrap);
      panel.appendChild(group);
    });
    bpUpdateAvail(panel, product, inlineSelectedOpts);

    const addBtnEl = document.createElement('button');
    addBtnEl.className = 'bp-inline-add-btn';
    addBtnEl.textContent = 'Select an option';
    addBtnEl.disabled = true;

    addBtnEl.addEventListener('click', (e) => {
      e.stopPropagation();
      if (!inlineVariant) return;

      const image = normalizeImgSrc(
        (inlineVariant.featured_image && inlineVariant.featured_image.src)
          || (product.images && product.images[0] && product.images[0].src)
          || product.featured_image
          || wrapper.dataset.image
      );

      const productData = {
        productId: String(product.id),
        variantId: String(inlineVariant.id),
        title:     product.title + (inlineVariant.title !== 'Default Title' ? ' — ' + inlineVariant.title : ''),
        price:     (inlineVariant.price / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' }),
        image:     image,
        handle:    product.handle,
      };

      const added = addToSelection(productData, wrapper);
      if (added) {
        updateCardQty(wrapper);
        setTimeout(() => closeInlineVariants(wrapper), 400);
      }
    });

    panel.appendChild(addBtnEl);
    loading.remove();
    wrapper.appendChild(panel);
  }
  function resolveInlineVariant(product, addBtnEl, wrapper) {
    inlineVariant = product.variants.find(v => {
      return product.options.every((opt, idx) => {
        const sel = inlineSelectedOpts[idx];
        if (!sel) return true;
        return v['option' + (idx + 1)] === sel;
      });
    }) || null;

    // ── Live image update on the card ──
    if (inlineVariant) {
      var newSrc = null;
      if (inlineVariant.featured_image && inlineVariant.featured_image.src) {
        newSrc = normalizeImgSrc(inlineVariant.featured_image.src);
      } else if (product.images && product.images[0]) {
        newSrc = normalizeImgSrc(product.images[0].src || product.images[0]);
      }
      if (newSrc && wrapper) {
        var cardImg = wrapper.querySelector('.bp-card-img');
        if (cardImg) {
          cardImg.style.transition = 'opacity 0.2s ease';
          cardImg.style.opacity = '0';
          setTimeout(function() {
            cardImg.src = newSrc;
            cardImg.style.opacity = '1';
          }, 150);
        }
      }
    }

    if (!inlineVariant) {
      // Check if all options are selected — if so, combination doesn't exist = Sold Out
      const allSelected = Object.keys(inlineSelectedOpts).length === (inlineProduct ? inlineProduct.options.length : 0);
      if (allSelected && inlineProduct && inlineProduct.options.length > 0) {
        addBtnEl.disabled = true;
        addBtnEl.textContent = 'Sold Out';
        addBtnEl.classList.add('bp-inline-add-btn--oos');
      } else {
        addBtnEl.disabled = true;
        addBtnEl.textContent = 'Select an option';
        addBtnEl.classList.remove('bp-inline-add-btn--oos');
      }
      return;
    }

    if (!inlineVariant.available) {
      addBtnEl.disabled = true;
      addBtnEl.textContent = 'Sold Out';
      addBtnEl.classList.add('bp-inline-add-btn--oos');
      return;
    }

    addBtnEl.disabled = false;
    addBtnEl.textContent = 'Add to Box';
    addBtnEl.classList.remove('bp-inline-add-btn--oos');
  }

  /* ── Card "Add" button click → open inline variant picker ── */
  section.addEventListener('click', (e) => {
    const addBtn = e.target.closest('.bp-card-add-btn');
    if (!addBtn || addBtn.disabled) return;

    const wrapper = addBtn.closest('.bp-card-wrapper');
    if (!wrapper) return;

    openInlineVariants(wrapper);
  });

  /* ── Card quantity minus button ── */
  section.addEventListener('click', (e) => {
    const minusBtn = e.target.closest('.bp-card-qty-minus');
    if (!minusBtn) return;

    const wrapper = minusBtn.closest('.bp-card-wrapper');
    if (!wrapper) return;

    const productId = wrapper.dataset.productId;

    // Remove the LAST added item belonging to this product (any variant)
    for (let i = selectedProducts.length - 1; i >= 0; i--) {
      if (selectedProducts[i] && String(selectedProducts[i].productId) === String(productId)) {
        selectedProducts[i] = null;
        break;
      }
    }

    const remaining = selectedProducts.filter(Boolean);
    selectedProducts = [...remaining, ...new Array(BUNDLE_SIZE - remaining.length).fill(null)];

    updateCardQty(wrapper);
    hideError();
    updateTrayUI();
  });

  /* ── Card quantity plus button ── */
  section.addEventListener('click', async (e) => {
    const plusBtn = e.target.closest('.bp-card-qty-plus');
    if (!plusBtn || plusBtn.disabled) return;

    const wrapper = plusBtn.closest('.bp-card-wrapper');
    if (!wrapper) return;

    const handle = wrapper.dataset.handle;

    // Check if product has real options — if single variant, add instantly
    try {
      const res = await fetch(`/products/${handle}.js`);
      const product = bpApplyExclusions(await res.json());
      const hasRealOptions =
        product.options.length > 0 &&
        !(product.options.length === 1 && product.options[0].name === 'Title') &&
        !(product.variants.length === 1);

      if (!hasRealOptions) {
        // Single variant — add instantly
        const v = product.variants[0];
        const image = normalizeImgSrc(
          (v.featured_image && v.featured_image.src)
            || (product.images && product.images[0] && product.images[0].src)
            || product.featured_image
            || wrapper.dataset.image
        );
        const productData = {
          productId: String(product.id),
          variantId: String(v.id),
          title:     product.title,
          price:     (v.price / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' }),
          image:     image,
          handle:    product.handle,
        };
        addToSelection(productData, wrapper);
      } else {
        // Multi-variant — open picker
        openInlineVariants(wrapper);
      }
    } catch(err) {
      openInlineVariants(wrapper);
    }
  });

  function getCardQty(wrapper) {
    const productId = wrapper.dataset.productId;
    // Count ALL selections belonging to this product regardless of variant
    return selectedProducts.filter(p => p && String(p.productId) === String(productId)).length;
  }

  function updateCardQty(wrapper) {
    const qty = getCardQty(wrapper);
    const addBtn = wrapper.querySelector('.bp-card-add-btn');
    const qtyEl = wrapper.querySelector('.bp-card-qty');
    const qtyNum = wrapper.querySelector('.bp-card-qty-num');
    const checkEl = wrapper.querySelector('.bp-card-check');
    const includedEl = wrapper.querySelector('.bp-card-included');
    const card = wrapper.querySelector('.bp-card');

    if (qty > 0) {
      if (addBtn) addBtn.style.display = 'none';
      if (qtyEl) { qtyEl.style.display = 'flex'; }
      if (qtyNum) qtyNum.textContent = qty;
      if (checkEl) checkEl.style.display = 'flex';
      if (includedEl) includedEl.style.display = 'block';
      if (card) card.classList.add('selected');

      // Disable plus if bundle full or qty at max 7
      const plusBtn = wrapper.querySelector('.bp-card-qty-plus');
      if (plusBtn) {
        const totalSelected = selectedProducts.filter(Boolean).length;
        plusBtn.disabled = totalSelected >= BUNDLE_SIZE || qty >= BUNDLE_SIZE;
        plusBtn.style.opacity = plusBtn.disabled ? '0.3' : '1';
      }
    } else {
      if (addBtn) addBtn.style.display = '';
      if (qtyEl) qtyEl.style.display = 'none';
      if (checkEl) checkEl.style.display = 'none';
      if (includedEl) includedEl.style.display = 'none';
      if (card) card.classList.remove('selected');
    }
  }

  /* ── Close inline panel when clicking outside ── */
  document.addEventListener('click', (e) => {
    if (activeInlineWrapper && !activeInlineWrapper.contains(e.target)) {
      closeAllInlineVariants();
    }
  });

  /* ── Quick View trigger ── */
  section.addEventListener('click', (e) => {
    const qvBtn = e.target.closest('.bp-card-qv-btn');
    if (!qvBtn) return;
    openQuickView(qvBtn.dataset.handle, qvBtn.closest('.bp-card-wrapper'));
  });

  /* ── Card tap anywhere else → Quick View ──
     Mobile has no hover, so the eye button is the only QV affordance and the
     photo — the biggest tap target — did nothing. Any tap on a card that isn't
     one of its controls (Add/qty, the eye — handled above, gallery dots, an
     open inline variant panel) opens the Quick View. Swipes on the gallery are
     native scrolls and never fire click, so the gallery keeps working. */
  section.addEventListener('click', (e) => {
    const cardEl = e.target.closest('.bp-card');
    if (!cardEl) return;
    if (e.target.closest('.bp-card-add-btn, .bp-card-qty, .bp-card-qv-btn, .bp-card-dots, .bp-inline-variants')) return;
    const wrapper = cardEl.closest('.bp-card-wrapper');
    if (!wrapper || !wrapper.dataset.handle) return;
    // Mid variant-pick on this card: leave the inline panel in charge.
    if (activeInlineWrapper === wrapper) return;
    openQuickView(wrapper.dataset.handle, wrapper);
  });

  /* ══════════════════════════════════════════
     QUICK VIEW MODAL (for browsing images/details)
     Add button inside QV also forces variant select
  ══════════════════════════════════════════ */
  const qvOverlay = document.getElementById('bp-qv-overlay');
  const qvClose   = document.getElementById('bp-qv-close');
  const qvImg     = document.getElementById('bp-qv-img');
  const qvThumbs  = document.getElementById('bp-qv-thumbs');
  const qvThumbsWrap = document.getElementById('bp-qv-thumbs-wrap');
  const qvThumbPrev  = document.getElementById('bp-qv-thumb-prev');
  const qvThumbNext  = document.getElementById('bp-qv-thumb-next');
  const qvVendor  = document.getElementById('bp-qv-vendor');
  const qvTitle   = document.getElementById('bp-qv-title');
  const qvPrice   = document.getElementById('bp-qv-price');
  const qvOptions = document.getElementById('bp-qv-options');
  const qvAddBtn  = document.getElementById('bp-qv-add-btn');
  const qvDesc    = document.getElementById('bp-qv-desc');

  let currentQVProduct  = null;
  let currentQVCardEl   = null;
  let qvSelectedOptions = {};
  let qvSelectedVariant = null;
  let qvImages          = [];
  let qvReq             = 0;   // request token: ignore stale fetches when switching fast

  function closeQuickView() {
    qvOverlay.style.display = 'none';
    document.documentElement.classList.remove('bp-qv-open');
    currentQVProduct = null;
    currentQVCardEl  = null;
  }

  qvClose.addEventListener('click', closeQuickView);
  qvOverlay.addEventListener('click', (e) => { if (e.target === qvOverlay) closeQuickView(); });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeQuickView(); });

  /* Keep the thumbnail row to one line; show arrows only when it overflows. */
  function updateThumbArrows() {
    if (!qvThumbsWrap || !qvThumbs) return;
    var overflow = qvThumbs.scrollWidth > qvThumbs.clientWidth + 2;
    qvThumbsWrap.classList.toggle('has-overflow', overflow);
    if (overflow) {
      if (qvThumbPrev) qvThumbPrev.classList.toggle('is-disabled', qvThumbs.scrollLeft <= 2);
      if (qvThumbNext) qvThumbNext.classList.toggle('is-disabled',
        qvThumbs.scrollLeft + qvThumbs.clientWidth >= qvThumbs.scrollWidth - 2);
    }
  }
  if (qvThumbPrev) qvThumbPrev.addEventListener('click', function () {
    qvThumbs.scrollBy({ left: -qvThumbs.clientWidth * 0.7, behavior: 'smooth' });
  });
  if (qvThumbNext) qvThumbNext.addEventListener('click', function () {
    qvThumbs.scrollBy({ left: qvThumbs.clientWidth * 0.7, behavior: 'smooth' });
  });
  if (qvThumbs) qvThumbs.addEventListener('scroll', updateThumbArrows, { passive: true });

  async function openQuickView(handle, cardEl) {
    const myReq = ++qvReq;
    currentQVCardEl = cardEl;
    qvOverlay.style.display = 'flex';
    // Lock the page behind the modal (mobile: touches were scrolling the page
    // instead of the Quick View). Released in closeQuickView.
    document.documentElement.classList.add('bp-qv-open');
    // Clear ALL prior-product content so we never flash the last product.
    qvTitle.textContent = 'Loading\u2026';
    qvVendor.textContent = '';
    qvPrice.textContent = '';
    qvOptions.innerHTML = '';
    qvDesc.innerHTML    = '';
    qvThumbs.innerHTML  = '';
    qvImg.removeAttribute('src');
    qvImg.alt = '';
    qvAddBtn.disabled   = true;
    qvAddBtn.classList.remove('active');

    // INSTANT image: show the card's on-screen photo (already in browser
    // cache) immediately, and start the real 900px hero IN PARALLEL with the
    // product fetch \u2014 its URL is derivable from the card's data-imgs, so it
    // doesn't have to wait the 150-600ms for product.js. The 900px variant is
    // almost always a cold CDN resize (~250-450ms+), so the head start counts.
    if (cardEl) {
      const cardImgEl = cardEl.querySelector('.bp-card-img--primary');
      const cardSrc = cardImgEl && (cardImgEl.currentSrc || cardImgEl.src);
      if (cardSrc) { qvImg.src = cardSrc; }
      const firstImg = ((cardEl.dataset.imgs || '').split('|')[0] || '')
        .replace(/_\d+x\d+_crop_center(?=\.)/, '');
      const heroUrl = firstImg ? qvSized(firstImg, 900) : '';
      if (heroUrl) {
        const pre = new Image();
        pre.decoding = 'async';
        pre.onload = function () {
          if (myReq === qvReq) qvImg.src = heroUrl;   // seamless swap when ready
        };
        pre.src = heroUrl;
      }
    }

    try {
      const res = await fetch(`/products/${handle}.js`);
      if (!res.ok) throw new Error('Product not found');
      const product = bpApplyExclusions(await res.json());
      if (myReq !== qvReq) return;   // a newer quick-view was opened; drop this one
      currentQVProduct = product;

      qvVendor.textContent = product.vendor || '';
      qvTitle.textContent  = product.title;
      // Render the FULL formatted description (workmanship + specifications +
      // sizing) rather than a stripped, 280-char-truncated preview.
      qvDesc.innerHTML = product.description || '';

      qvImages = (product.images && product.images.length)
        ? product.images
        : (product.featured_image ? [{ src: product.featured_image }] : []);

      if (qvImages.length) {
        qvImg.decoding = 'async';
        const mainUrl = qvSized(qvImages[0].src || qvImages[0], 900);
        // Don't blank the instant card-image placeholder by assigning a
        // still-downloading URL — swap only once it's loaded. (Usually this is
        // the same URL the parallel pre-loader already started at open.)
        if (qvImg.getAttribute('src')) {
          const main = new Image();
          main.decoding = 'async';
          main.onload = function () { if (myReq === qvReq) qvImg.src = mainUrl; };
          main.src = mainUrl;
        } else {
          qvImg.src = mainUrl;
        }
        qvImg.alt = product.title;
        qvThumbs.innerHTML = '';
        var fullUrls = [];
        qvImages.slice(0, 30).forEach((imgObj, i) => {
          var full = qvSized(imgObj.src || imgObj, 900);
          if (!full) return;
          fullUrls.push(full);
          const thumb = document.createElement('img');
          thumb.className = 'bp-qv-thumb' + (i === 0 ? ' active' : '');
          thumb.src = qvSized(imgObj.src || imgObj, 150);
          thumb.alt = '';
          thumb.loading = 'lazy';
          thumb.addEventListener('click', () => {
            qvImg.src = full;
            qvThumbs.querySelectorAll('.bp-qv-thumb').forEach(t => t.classList.remove('active'));
            thumb.classList.add('active');
          });
          thumb.addEventListener('error', () => { thumb.style.display = 'none'; });
          qvThumbs.appendChild(thumb);
        });

        // Preload full (900px) versions in the background so clicking a
        // thumbnail swaps instantly. CAPPED at the first 8 — preloading all
        // ~10 (~500KB) hogged the connection and made the NEXT quick-view's
        // main image queue behind it (the "sometimes very slow" complaint).
        var preload = function () {
          fullUrls.slice(1, 9).forEach(function (u) {
            var im = new Image();
            im.decoding = 'async';
            im.src = u;
          });
        };
        if (window.requestIdleCallback) {
          requestIdleCallback(preload, { timeout: 2500 });
        } else {
          setTimeout(preload, 600);
        }

        if (qvThumbs) qvThumbs.scrollLeft = 0;
        updateThumbArrows();
      }

      renderQVOptions(product);
    } catch (err) {
      qvTitle.textContent = 'Could not load product.';
    }
  }

  const COLOR_SWATCHES = {
    'gold': '#E8CC8B', 'silver': '#D2D2D2',
    'rose gold': '#D9B9B2', 'rose-gold': '#D9B9B2', 'rose': '#D9B9B2',
    'oxyn black': '#1c1c1c', 'pearl white': '#f1ece1', 'sky blue': '#9cc3e0',
    'lucky green': '#2f7d54', 'red wine': '#6e1f2e',
    'black': '#1c1c1c', 'white': '#f1ece1', 'green': '#2f7d54',
    'blue': '#9cc3e0', 'red': '#7a2233', 'pink': '#e9a9b8', 'purple': '#7d5a9c',
    // resin/acrylic bangle colourways
    'rosa': '#E8A0B0', 'chocolate': '#5c4033', 'beige': '#e8d9c0', 'cream': '#f3ead8',
    'arancia': '#e8852b', 'avocado': '#5b6e3a', 'black marble': '#2a2a2a', 'coconut': '#ede6da',
    'grape': '#6e4b8b', 'grigio': '#9a9a9a', 'guava': '#e58b7b', 'kiwi': '#7cb342',
    'lavender': '#c9b6e4', 'lemon': '#ebd94a', 'lime': '#9ccb3b', 'mango': '#f4b400',
    'blu': '#4a78c4', 'strawberry': '#d33a4b', 'white marble': '#ecece8', 'clear': '#dce4e8'
  };
  function swatchColor(val) {
    return bpSwatchColor(val); // unified with inline picker (metals + gems + birthstone colours)
  }

  function renderQVOptions(product) {
    qvOptions.innerHTML = '';
    qvSelectedOptions   = {};
    qvSelectedVariant   = null;

    const hasRealOptions =
      product.options.length > 0 &&
      !(product.options.length === 1 && product.options[0].name === 'Title');

    if (!hasRealOptions) {
      qvSelectedVariant = product.variants[0];
      updateQVPrice();
      updateQVAddBtn();
      return;
    }

    product.options.forEach((option, idx) => {
      const group = document.createElement('div');
      group.className = 'bp-option-group';
      const label = document.createElement('div');
      label.className = 'bp-option-label';
      label.textContent = option.name;
      const isColor = bpIsColorOption(option.name);
      const values = document.createElement('div');
      values.className = 'bp-option-values';
      [...new Set(option.values)].forEach(val => {
        let swatch = isColor ? bpSwatchColor(val) : null;
        // Same fallback as the inline picker: unknown colour name → that
        // variant's product photo as the swatch (instead of a text button).
        if (isColor && !swatch) {
          const img = bpVariantImageFor(product, idx, val);
          if (img) swatch = 'url("' + img + '") center/cover no-repeat';
        }
        const btn = document.createElement('button');
        btn.dataset.optIdx = idx;
        btn.dataset.optVal = val;
        if (swatch) {
          btn.className = 'bp-option-btn bp-swatch';
          btn.style.setProperty('--swatch', swatch);
          btn.title = val;
          btn.setAttribute('aria-label', val);
        } else {
          btn.className = 'bp-option-btn';
          btn.textContent = val;
        }
        btn.addEventListener('click', () => {
          values.querySelectorAll('.bp-option-btn').forEach(b => b.classList.remove('active'));
          btn.classList.add('active');
          qvSelectedOptions[idx] = val;
          if (isColor) label.textContent = option.name + ': ' + val;
          resolveQVVariant(product);
          bpUpdateAvail(qvOptions, product, qvSelectedOptions);
        });
        values.appendChild(btn);
      });
      group.appendChild(label);
      group.appendChild(values);
      qvOptions.appendChild(group);
    });

    bpUpdateAvail(qvOptions, product, qvSelectedOptions);
    resolveQVVariant(product);
  }

  function resolveQVVariant(product) {
    qvSelectedVariant = product.variants.find(v =>
      product.options.every((opt, idx) => {
        const sel = qvSelectedOptions[idx];
        return !sel || v['option' + (idx + 1)] === sel;
      })
    ) || null;

    if (qvSelectedVariant && qvSelectedVariant.featured_image) {
      qvImg.src = qvSized(qvSelectedVariant.featured_image.src, 900);
    }
    updateQVPrice();
    updateQVAddBtn();
  }

  function updateQVPrice() {
    if (qvSelectedVariant) {
      qvPrice.textContent = (qvSelectedVariant.price / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    } else {
      qvPrice.textContent = '';
    }
  }

  function updateQVAddBtn() {
    if (!qvSelectedVariant) {
      qvAddBtn.disabled = true;
      qvAddBtn.textContent = 'Select options above';
      return;
    }
    if (!qvSelectedVariant.available) {
      qvAddBtn.disabled = true;
      qvAddBtn.textContent = 'Out of Stock';
      qvAddBtn.classList.add('bp-qv-add-btn--oos');
      return;
    }
    qvAddBtn.classList.remove('bp-qv-add-btn--oos');
    const bundleFull = selectedProducts.filter(Boolean).length >= BUNDLE_SIZE;
    qvAddBtn.disabled = bundleFull;
    qvAddBtn.classList.toggle('active', !bundleFull);
    qvAddBtn.textContent = bundleFull ? 'Bundle Full' : 'Add to Box';
  }

  qvAddBtn.addEventListener('click', () => {
    if (!qvSelectedVariant || !currentQVProduct) return;
    const image = normalizeImgSrc(
      (qvSelectedVariant.featured_image && qvSelectedVariant.featured_image.src)
        || (currentQVProduct.images && currentQVProduct.images[0] && currentQVProduct.images[0].src)
        || currentQVProduct.featured_image
    );
    const productData = {
      productId: String(currentQVProduct.id),
      variantId: String(qvSelectedVariant.id),
      title:     currentQVProduct.title + (qvSelectedVariant.title !== 'Default Title' ? ' \u2014 ' + qvSelectedVariant.title : ''),
      price:     (qvSelectedVariant.price / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' }),
      image:     image,
      handle:    currentQVProduct.handle,
    };
    const added = addToSelection(productData, currentQVCardEl);
    if (added) {
      updateQVAddBtn();
      setTimeout(() => closeQuickView(), 500);
    }
  });

  /* ══════════════════════════════════════════════════════════════════
     CHECKOUT HANDOFF  (front-end only — no backend baked in)
     ──────────────────────────────────────────────────────────────────
     This UI does NOT process checkout itself. When the customer has all
     7 items selected and clicks the button, we hand the full selection
     off to YOUR cart/checkout code. You can hook in two ways — use
     whichever you like (both fire on every valid click):

       1) Global callback — define before or after this script loads:
            window.BP_CONFIG.onCheckout = function (bundle) { ... };

       2) DOM custom event on `document`:
            document.addEventListener('bundle:checkout', function (e) {
              var bundle = e.detail;   // same payload as the callback
            });

     The `bundle` payload:
       {
         items: [                       // exactly 7, in slot order
           { variantId, productId, title, price, handle, image }, ...
         ],
         bundleSize:      7,
         bundlePrice:     8500,         // cents ($85.00)
         bundleVariantId: 1234567890    // "Pick Any 7" variant, if set in theme editor
       }

     Helpers exposed for your checkout code to drive button/error state:
       window.BP_CONFIG.setCheckoutLoading(true | false);
       window.BP_CONFIG.showCheckoutError('message');
       window.BP_CONFIG.clearCheckoutError();
       window.BP_CONFIG.getSelection();   // returns the items array anytime
  ══════════════════════════════════════════════════════════════════ */

  function setCheckoutLoading(isLoading) {
    if (isLoading) {
      // "bp-loading" (not "loading") avoids the theme's global .loading
      // line-bar animation; the spinner + this label center together via flex.
      checkoutBtn.textContent = 'Preparing checkout…';
      checkoutBtn.classList.add('bp-loading');
      checkoutBtn.disabled = true;
    } else {
      checkoutBtn.classList.remove('bp-loading');
      updateTrayUI(); // restores correct label + enabled/disabled state
    }
  }

  function getSelection() {
    return selectedProducts.filter(Boolean).map(function (p) {
      return {
        variantId: p.variantId,
        productId: p.productId,
        title:     p.title,
        price:     p.price,
        handle:    p.handle,
        image:     p.image
      };
    });
  }

  // Expose helpers on BP_CONFIG so the dev's code can call them.
  window.BP_CONFIG = window.BP_CONFIG || {};
  window.BP_CONFIG.setCheckoutLoading = setCheckoutLoading;
  window.BP_CONFIG.showCheckoutError  = showError;
  window.BP_CONFIG.clearCheckoutError = hideError;
  window.BP_CONFIG.getSelection       = getSelection;

  checkoutBtn.addEventListener('click', function () {
    const items = getSelection();
    if (items.length !== BUNDLE_SIZE) {
      showError(`Please select all ${BUNDLE_SIZE} items to continue.`);
      return;
    }
    hideError();

    const bundle = {
      items:           items,
      bundleSize:      BUNDLE_SIZE,
      bundlePrice:     BUNDLE_PRICE,   // cents, from BP_CONFIG (offer-agnostic)
      bundleVariantId: BUNDLE_VARIANT_ID
    };

    // Meta Pixel: fire InitiateCheckout when the customer clicks Checkout
    // with a complete bundle.
    bpTrackPixel('InitiateCheckout', {
      content_ids:  items.map(function (i) { return i.variantId; }),
      content_type: 'product',
      num_items:    items.length,
      value:        bundle.bundlePrice / 100,
      currency:     'USD'
    });

    // 1) Global callback, if the dev defined one.
    if (typeof window.BP_CONFIG.onCheckout === 'function') {
      try { window.BP_CONFIG.onCheckout(bundle); }
      catch (err) { console.error('[bundle-picker] onCheckout threw:', err); }
    }

    // 2) Custom event — always dispatched.
    document.dispatchEvent(new CustomEvent('bundle:checkout', { detail: bundle }));

    // If nobody has wired up a handler yet, make that obvious during dev
    // instead of failing silently.
    if (typeof window.BP_CONFIG.onCheckout !== 'function') {
      console.warn('[bundle-picker] Bundle ready, but no checkout handler is ' +
        'attached. Listen for the "bundle:checkout" event or set ' +
        'window.BP_CONFIG.onCheckout to handle cart + checkout.', bundle);
    }
  });




// document.addEventListener('bundle:checkout', async function(event) {

//   const bundle = event.detail;

//   const bundleId = 'BUNDLE_' + Date.now();

//   // Show the "Preparing checkout…" loading state immediately while we build
//   // the cart and redirect (this takes a few seconds).
//   setCheckoutLoading(true);

//   const items = [];


//   // Parent bundle product
//   items.push({

//     id: bundle.bundleVariantId,

//     quantity: 1,

//     properties: {

//       "_bundleId": bundleId,

//       "_bundleType": "Parent Bundle"

//     }

//   });



//   // Selected products
//   const grouped = {};


//   bundle.items.forEach(item => {

//     grouped[item.variantId] =
//       (grouped[item.variantId] || 0) + 1;

//   });



//   Object.keys(grouped).forEach(id => {


//     items.push({

//       id: Number(id),

//       quantity: grouped[id],

//       properties: {

//         "_bundleId": bundleId,

//         "_bundleType": "Bundle Item"

//       }

//     });


//   });




//   // Add to cart, then redirect to checkout with the bundle discount.
//   try {
//     const res = await fetch('/cart/add.js', {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json'
//       },
//       body: JSON.stringify({
//         items: items
//       })
//     });
//     if (!res.ok) throw new Error('cart/add failed: ' + res.status);

//     // Keep the loading state visible through the redirect.
//     window.location.href = '/checkout?discount=BUNDLE7';
//   } catch (err) {
//     console.error('[bundle-picker] checkout failed:', err);
//     setCheckoutLoading(false);
//     if (typeof showError === 'function') {
//       showError('Something went wrong preparing your checkout. Please try again.');
//     }
//   }

// });



// document.addEventListener('bundle:checkout', async function(event) {

//   const bundle = event.detail;
//   const bundleId = 'BUNDLE_' + Date.now();

//   let bundlePayload = {
//     bundleId: bundleId,
//     bundleVariantId: `gid://shopify/ProductVariant/${bundle.bundleVariantId}`,
//     bundleParent: {
//       _bundleId: bundleId,
//       _bundle_count: bundle.bundleSize,
//       _bundleParent: 'true'
//     },
//     bundleItems: []
//   };

//   const grouped = {};

//   bundle.items.forEach(item => {
//     grouped[item.variantId] = (grouped[item.variantId] || 0) + 1;
//   });

//   Object.keys(grouped).forEach(variantId => {
//     bundlePayload.bundleItems.push({
//       variantId: `gid://shopify/ProductVariant/${variantId}`,
//       quantity: grouped[variantId],
//       properties: {
//         _bundleId: bundleId
//       }
//     });
//   });

//   console.log('Draft Payload:', bundlePayload);

//   setCheckoutLoading(true);

//   try {

//     // -----------------------------
//     // ADD TO CART
//     // -----------------------------
//     const cartItems = [];

//     cartItems.push({
//       id: Number(bundle.bundleVariantId),
//       quantity: 1,
//       properties: {
//         _bundleId: bundleId,
//         _bundle_count: bundle.bundleSize,
//         _bundleParent: 'true'
//       }
//     });

//     Object.keys(grouped).forEach(variantId => {
//       cartItems.push({
//         id: Number(variantId),
//         quantity: grouped[variantId],
//         properties: {
//           _bundleId: bundleId
//         }
//       });
//     });

//     const cartResponse = await fetch('/cart/add.js', {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json'
//       },
//       body: JSON.stringify({
//         items: cartItems
//       })
//     });

//     if (!cartResponse.ok) {
//       throw new Error('Failed to add bundle to cart');
//     }

//     console.log('Bundle added to cart');

//     // -----------------------------
//     // CREATE DRAFT ORDER
//     // -----------------------------
//     const response = await fetch('/apps/draft/', {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json'
//       },
//       body: JSON.stringify(bundlePayload)
//     });

//     const result = await response.json();

//     console.log('Draft Response:', result);

//     if (result.success && result.invoiceUrl) {
//       window.location.href = result.invoiceUrl;
//       return;
//     }

//     throw new Error(result.message || 'Unable to create draft order');

//   } catch (error) {

//     console.error(error);

//     setCheckoutLoading(false);

//     showError(
//       error.message ||
//       'Something went wrong preparing your checkout. Please try again.'
//     );
//   }

// });


document.addEventListener('bundle:checkout', async function(event) {

    const bundle = event.detail;

    const grouped = {};
    const bundleId = 'BUNDLE_' + Date.now();

    bundle.items.forEach(item => {
        grouped[item.variantId] =
            (grouped[item.variantId] || 0) + 1;
    });

    const cartItems = [];
 setCheckoutLoading(true);
    // Parent ($85 line). The 7 children below get 100% off via the automatic
    // Shopify discount FUNCTION (reads _bundleType), so the bundle nets $85 —
    // no draft order / server needed.
    cartItems.push({
        id: Number(bundle.bundleVariantId),
        quantity: 1,
        properties: {
            _bundleId: bundleId,
            _bundleType: "Parent Bundle"
        }
    });

    // Children (the 7 picks)
    Object.keys(grouped).forEach(variantId => {
        cartItems.push({
            id: Number(variantId),
            quantity: grouped[variantId],
            properties: {
                _bundleId: bundleId,
                _bundleType: "Bundle Item"
            }
        });
    });

    // /cart/add.js puts each newly added line on TOP of the cart, so send the
    // lines in reverse: parent last → parent shows FIRST at checkout, with its
    // pieces underneath in picked order.
    cartItems.reverse();

    try {

        // REPLACE any bundle already in the cart. Without this, Back-button →
        // CHECKOUT again stacked a SECOND full bundle (the first add survives
        // the redirect in the cart). Zero out every line carrying _bundleType.
        // (no-store: a disk-cached cart snapshot here would miss/mismatch line
        // keys and break the replace — same staleness as restoreFromCart.)
        const cart = await fetch('/cart.js?t=' + Date.now(), { cache: 'no-store' }).then(r => r.json());
        const stale = {};
        (cart.items || []).forEach(function (it) {
            if (it.properties && it.properties._bundleType) stale[it.key] = 0;
        });
        if (Object.keys(stale).length) {
            const clearResponse = await fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ updates: stale })
            });
            if (!clearResponse.ok) {
                throw new Error('Failed to clear the previous bundle from cart');
            }
        }

        // Add the bundle to the cart, then go to standard checkout. The
        // automatic discount function prices it in the cart and at checkout.
        const addResponse = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                items: cartItems
            })
        });

        if (!addResponse.ok) {
            throw new Error('Failed to add bundle to cart');
        }

        window.location.href = '/checkout';

    } catch (error) {
        console.error(error);
        setCheckoutLoading(false);
        if (typeof showError === 'function') {
            showError('Something went wrong preparing your checkout. Please try again.');
        }
    }

});










// document.addEventListener('bundle:checkout', async function(event) {

//   const bundle = event.detail;

//   const bundleId = 'BUNDLE_' + Date.now();


//   setCheckoutLoading(true);


//   try {


//     // ---------------------------------
//     // ADD BUNDLE ITEMS TO CART
//     // ---------------------------------

//     const grouped = {};


//     bundle.items.forEach(item => {

//       grouped[item.variantId] =
//         (grouped[item.variantId] || 0) + 1;

//     });



//     const cartItems = [];


//     // Parent bundle product
//     cartItems.push({

//       id: Number(bundle.bundleVariantId),

//       quantity: 1,

//       properties: {

//         _bundleId: bundleId

//       }

//     });



//     // Child products

//     Object.keys(grouped).forEach(variantId => {


//       cartItems.push({

//         id: Number(variantId),

//         quantity: grouped[variantId],

//         properties: {

//           _bundleId: bundleId

//         }

//       });


//     });




//     const cartAdd = await fetch('/cart/add.js', {

//       method: 'POST',

//       headers: {

//         'Content-Type': 'application/json'

//       },

//       body: JSON.stringify({

//         items: cartItems

//       })

//     });



//     if(!cartAdd.ok){

//       throw new Error('Cart add failed');

//     }



//     console.log('Bundle added to cart');




//     // ---------------------------------
//     // GET COMPLETE CART
//     // ---------------------------------

//     const cart = await fetch('/cart.js')
//       .then(res => res.json());



//     console.log('Current Cart:', cart);




//     // ---------------------------------
//     // CREATE DRAFT PAYLOAD
//     // ---------------------------------

//     let draftPayload = {

//       lineItems: []

//     };




//     cart.items.forEach(item => {



//       let lineItem = {


//         variantId:
//         `gid://shopify/ProductVariant/${item.variant_id}`,

//         quantity:
//         item.quantity


//       };




//       // ONLY BUNDLE ITEMS GET DISCOUNT

//       if(
//         item.properties &&
//         item.properties._bundleId
//       ){


//         lineItem.customAttributes = [


//           {

//             key: "_bundleId",

//             value: item.properties._bundleId


//           }


//         ];



//         lineItem.appliedDiscount = {


//           title: "Bundle Item Free",

//           valueType: "PERCENTAGE",

//           value: 100


//         };


//       }




//       draftPayload.lineItems.push(lineItem);



//     });




//     console.log(
//       "Draft Payload:",
//       draftPayload
//     );




//     // ---------------------------------
//     // CREATE DRAFT ORDER
//     // ---------------------------------

//     const response = await fetch('/apps/draft/', {

//       method:'POST',

//       headers:{

//         'Content-Type':'application/json'

//       },

//       body:JSON.stringify(draftPayload)

//     });



//     const result = await response.json();



//     console.log(
//       "Draft Response:",
//       result
//     );




//     if(result.success && result.invoiceUrl){


//       window.location.href =
//       result.invoiceUrl;


//       return;

//     }




//     throw new Error(
//       result.message ||
//       'Draft order failed'
//     );




//   }

//   catch(error){


//     console.error(error);


//     setCheckoutLoading(false);


//     showError(
//       error.message ||
//       'Something went wrong'
//     );


//   }


// });




// When the customer hits the browser Back button after being sent to checkout,
// the page is restored from the back-forward cache (bfcache) frozen exactly as
// it was — leaving the button stuck on "Preparing checkout…". Reset it so they
// land back on a clickable CHECKOUT button.
window.addEventListener('pageshow', function (e) {
  if (e.persisted) setCheckoutLoading(false);
});








  function showError(msg) {
    if (errorEl) { errorEl.textContent = msg; errorEl.style.display = 'block'; }
  }

  function hideError() {
    if (errorEl) errorEl.style.display = 'none';
  }

  /* ── Mobile image swipe: sync pagination dots with the scroll position ──
     Per-track so it can run for both the server-rendered cards (at boot) and
     cards materialized later. Guarded by data-galleryInit so a track is never
     wired twice (boot + materialize would otherwise double-bind). */
  function initCardGallery(track) {
    if (!track || track.dataset.galleryInit) return;
    track.dataset.galleryInit = '1';

    // Load deferred slides (3rd-5th images) on first interaction with this card.
    var deferred = track.querySelectorAll('img[data-bp-src]');
    if (deferred.length) {
      var loadDeferred = function () {
        deferred.forEach(function (img) {
          img.src = img.getAttribute('data-bp-src');
          img.removeAttribute('data-bp-src');
        });
        track.removeEventListener('touchstart', loadDeferred);
        track.removeEventListener('scroll', loadDeferred);
      };
      track.addEventListener('touchstart', loadDeferred, { passive: true });
      track.addEventListener('scroll', loadDeferred, { passive: true });
    }

    var wrap = track.parentElement;
    var dotsWrap = wrap && wrap.querySelector('[data-bp-dots]');
    if (!dotsWrap) return;
    var dots = dotsWrap.querySelectorAll('.bp-card-dot');
    if (dots.length < 2) return;

    var raf = null;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        var w = track.clientWidth || 1;
        var i = Math.round(track.scrollLeft / w);
        if (i < 0) i = 0;
        if (i > dots.length - 1) i = dots.length - 1;
        dots.forEach(function (d, idx) { d.classList.toggle('active', idx === i); });
      });
    }, { passive: true });

    dots.forEach(function (d, idx) {
      d.addEventListener('click', function (e) {
        e.stopPropagation();
        track.scrollTo({ left: idx * track.clientWidth, behavior: 'smooth' });
      });
    });
  }

  function initCardGalleries() {
    section.querySelectorAll('.bp-card-track').forEach(initCardGallery);
  }

  /* ── Deep-link: ?filter=<category label> activates that tab; ?sort=new sorts newest. ── */
  function applyUrlFilters() {
    var params = new URLSearchParams(window.location.search);
    var filter = params.get('filter');
    var sort = params.get('sort');
    var color = params.get('color');

    // ?sort=new (home "New In"/"Just Dropped" links) → activate the Just Dropped tab.
    if (sort === 'new' || sort === 'newest') {
      var jd = Array.prototype.find.call(tabs, function (t) { return t.dataset.tab === 'just-dropped'; });
      if (jd) jd.click();
    } else if (filter) {
      // ?filter=Necklaces etc. → activate the matching category tab by label.
      var want = filter.trim().toLowerCase();
      var target = Array.prototype.find.call(tabs, function (t) {
        return (t.textContent || '').trim().toLowerCase() === want;
      });
      if (target) target.click();
    }

    // ?color=silver etc. → activate the matching color filter.
    if (color) {
      var cw = color.trim().toLowerCase();
      var ct = Array.prototype.find.call(colorTabs, function (t) { return t.dataset.color === cw; });
      if (ct) ct.click();
    }
  }

  /* ── The picker EDITS the bundle in the cart ──
     If the cart already holds a bundle (customer clicked checkout earlier and
     came back — back button, cart icon, next day…), pre-load its pieces into
     the picker so what's on screen always matches the cart. Checkout then
     REPLACES the cart bundle, so nothing vanishes silently and re-checkout
     can't duplicate. Restoring bypasses addToSelection on purpose: no Pixel
     AddToCart, no pop sound, no confetti for pieces that were already chosen. */
  function restoreFromCart() {
    // cache:'no-store' + timestamp: on BACK-button (history) navigations the
    // browser may serve fetch('/cart.js') from disk cache WITHOUT revalidating
    // — restoring a stale snapshot of the cart (owner repro'd: edited bundle
    // reverted to the pre-edit pieces). Force a network read.
    fetch('/cart.js?t=' + Date.now(), { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.items) return;
        if (selectedProducts.filter(Boolean).length) return;   // already picking — don't clobber
        var pieces = cart.items.filter(function (it) {
          return it.properties && it.properties._bundleType === 'Bundle Item';
        });
        if (!pieces.length) return;
        var slot = 0;
        pieces.forEach(function (line) {
          for (var q = 0; q < line.quantity && slot < BUNDLE_SIZE; q++) {
            selectedProducts[slot++] = {
              productId: String(line.product_id),
              variantId: String(line.id),
              title: line.product_title +
                (line.variant_title && line.variant_title !== 'Default Title' ? ' — ' + line.variant_title : ''),
              price: (line.price / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' }),
              image: normalizeImgSrc(line.image || ''),
              handle: line.handle
            };
          }
        });
        if (!slot) return;
        updateTrayUI();
        repaintSelectedCards();
      })
      .catch(function () { /* cart unreachable — start empty */ });
  }

  /* ── Same-page anchors: JS scroll instead of native hash navigation ──
     iOS Safari caches the page scale per orientation; after rotating sideways
     and back, a NATIVE anchor jump (the "#bundle-picker" CTA buttons) can
     re-apply the stale landscape scale → page ends up zoomed/offset (owner
     repro'd: only happens when tapping the CTAs). scrollIntoView never
     touches the scale. */
  document.addEventListener('click', function (e) {
    const a = e.target.closest && e.target.closest('a[href^="#"]');
    if (!a) return;
    const id = a.getAttribute('href').slice(1);
    if (!id) return;
    const target = document.getElementById(id);
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  /* ── Init ── */
  const hadSession = restoreFromSession();   // sync — runs before first paint
  bpStateReady = true;
  updateTrayUI();
  if (hadSession) repaintSelectedCards();
  initCardGalleries();
  applyUrlFilters();
  if (!hadSession) restoreFromCart();   // fallback: new tab / next day → the cart

  } // end boot()

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();